/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, inject, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { filter } from 'rxjs/operators';
import { RedlineLayerConfiguration } from '../../../components/redline/state/redline.model';
import { AppConfigState } from '../../../core/state/appConfig/app-config.state';
import { LoggerService } from '../../shared/services/logger.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'dash-gis-redline-icon',
    templateUrl: './redline-icon.component.html',
    styleUrls: ['./redline-icon.component.scss'],
    imports: [AsyncPipe],
})
export class RedlineIconComponent implements OnInit {
    @Input() public redlineClassName: string;
    @Input() public redlineConfig: RedlineLayerConfiguration;

    private legendIcons$ = inject(Store).select(AppConfigState.legendIcons);

    constructor(private logger: LoggerService) {}

    ngOnInit() {}

    getLinePoints(width: number, height: number) {
        return [4, height - 1, (width - 1) / 2, 0, (width * 2) / 3, height - 1, width - 2, 0];
    }

    get iconDimensions$() {
        return this.legendIcons$.pipe(filter((b) => !!b));
    }

    get classConfig() {
        return this.redlineConfig.classes[this.redlineClassName];
    }
}
